document.addEventListener("DOMContentLoaded", function () {
  const image_text_modal_popup = document.querySelector(
    ".image-text-modal-popup"
  );
  if (
    image_text_modal_popup &&
    getCookie("modalPopupID") != image_text_modal_popup.id
  ) {
    image_text_modal_popup.classList.remove("d-none");
    document
      .querySelector(".image-text-modal-popup .btn-close")
      .addEventListener("click", function () {
        document
          .querySelector(".image-text-modal-popup")
          .classList.add("d-none");
        if (image_text_modal_popup.id)
          document.cookie = `modalPopupID=${image_text_modal_popup.id}`;
      });
  }

  /* Product subscription */
  setTimeout(()=> {
    updateProductPrice();

    const allOptions = document.querySelectorAll('[name="selling_plan"]');
    allOptions.forEach(item => {
      item.addEventListener('click', ()=> { updateProductPrice(); });
    });  
  }, 700);

  function updateProductPrice() {
    let subscriptionActive = document.querySelector('.appstle_sub_widget');
    if(!subscriptionActive) return;
    let currentOption = subscriptionActive.querySelector('[name="selling_plan"]:checked');
    if(!currentOption) return;
    let currentPrice = currentOption.parentNode.querySelector('.appstle_subscription_amount');
  
    document.querySelector('[data-product-price]').innerText = currentPrice.innerHTML;
  }
  
  /* Product thumbnails scroll on mobile */
  let mouseDown = false;
  let startX, scrollLeft;
  const thumbslider = null/* thumbnails now scroll natively, see custom.css */;
  if (thumbslider) {
    let offset = thumbslider.getBoundingClientRect();
    const startDragging = (e) => {
      mouseDown = true;
      startX = e.touches[0].pageX - offset.left;
      scrollLeft = thumbslider.scrollLeft;
    };
    const stopDragging = (e) => {
      mouseDown = false;
    };
    const move = (e) => {
      if (!mouseDown) {
        return;
      }
      const x = e.touches[0].pageX - offset.left;
      const scroll = x - startX;
      thumbslider.scrollLeft = scrollLeft - scroll;
    };
    // Add the event listeners
    thumbslider.addEventListener("touchmove", move, false);
    thumbslider.addEventListener("touchstart", startDragging, false);
    thumbslider.addEventListener("touchend", stopDragging, false);
    thumbslider.addEventListener("touchcancel", stopDragging, false);
  }

  //Add class to body when Bundle section reaches top
  /*For Bundle page */
  setTimeout(() => {
    const sectionBundle = document.querySelector('.rebuy-bundle-builder');
    const footer = document.querySelector('.section-footer');
    if (!sectionBundle || !footer) return;
    let footerVisible = false;
    // Observe footer
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        footerVisible = entry.isIntersecting;
        updateClass();
      });
    }, {
      root: null,
      threshold: 0
    });
    // Observe section
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        sectionBundle.dataset.inView = entry.isIntersecting; // store state
        updateClass();
      });
    }, {
      root: null,
      rootMargin: '0px 0px -85% 0px',
      threshold: 0
    });
    // Helper to update class
    function updateClass() {
      const inView = sectionBundle.dataset.inView === "true";
      if (inView && !footerVisible) {
        sectionBundle.classList.add('section-at-top');
      } else {
        sectionBundle.classList.remove('section-at-top');
      }
    }
    sectionObserver.observe(sectionBundle);
    footerObserver.observe(footer);
  }, 3000);
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

document.addEventListener('rebuy:cart.change', (event) => {
    // Step variables
    const subscriptionInfo = window.theme.settings.subscription_cancel_info;
    const subscriptionHtml = document.createElement("p"); // Create a new <p> element
    subscriptionHtml.className = "subscription-info"; // Add the class to the element
    subscriptionHtml.innerHTML = subscriptionInfo;
    const wrapper = document.querySelector('.rebuy-cart__flyout-integration');

  if(event.detail.cart.cartHasSubscriptionItems()){
    wrapper.innerHTML = ''
      wrapper.appendChild(subscriptionHtml);
      subscriptionHtml.classList.add('is-visible');
  }else {
    document.querySelectorAll('.subscription-info').forEach(item =>{
      item.remove()
    })
  }
});

// document.addEventListener('rebuy:cart.change', (event) => {
//   const wrapper = document.querySelector('.rebuy-cart__flyout-integration');
//   if (!wrapper) return; // Rebuy flyout not mounted on this page (e.g. /cart?viewcart=true)

//   const subscriptionInfo = window.theme.settings.subscription_cancel_info;

//   if (event.detail.cart.cartHasSubscriptionItems()) {
//     console.log("subscription added");
//     const subscriptionHtml = document.createElement("p");
//     subscriptionHtml.className = "subscription-info is-visible";
//     subscriptionHtml.innerHTML = subscriptionInfo;
//     wrapper.innerHTML = '';
//     wrapper.appendChild(subscriptionHtml);
//   } else {
//     console.log("subscription removed");
//     document.querySelectorAll('.subscription-info').forEach(item => item.remove());
//   }
// });

// PROCESS REBUY CUSTOM ADD TO CART EVENT
document.addEventListener("rebuy:cart.add", function (event) {
  const productUpsellWidget = document.querySelector('.product-content .rebuy-widget');
  if(productUpsellWidget)
    productUpsellWidget.classList.add('is-hidden');
});

//Click to go top
const topListener = document.querySelector(".thumbnails-overflow-indicator-top")
if (topListener) {
  topListener.addEventListener("click", goTop);
}
function goTop() {
  document.querySelector(".product-thumbnail-list").style.cssText="transition:all 0.2s ease;transform:translateY(0);";
}

// Sticky Newsletter

const stickyNewsletterContainer = document.querySelector('[data-newsletter-container]')
const desktopId = stickyNewsletterContainer.getAttribute('data-newsletter-desktop-id');
const mobileId = stickyNewsletterContainer.getAttribute('data-newsletter-mobile-id');
const stickyNewsletterButton = document.querySelector('[data-newsletter-button]')
const stickyNewsletterClose = document.querySelector('[data-newsletter-close]')
const hideCookieName = 'hideStickyNewsletter'
const checkNewsletterCookie = getCookie(hideCookieName)

if (checkNewsletterCookie === 'true') {
  stickyNewsletterContainer.classList.add('is-hidden')
} else {
  stickyNewsletterContainer.classList.remove('is-hidden')
}

stickyNewsletterClose.addEventListener('click', () => { 
  stickyNewsletterContainer.classList.add('is-hidden')
  setCookie(hideCookieName, true, 3)
});

function openStickyNewsletterForm() {
  window._klOnsite = window._klOnsite || [];
  
  if (window.innerWidth >= 990) {
    window._klOnsite.push(['openForm', desktopId]);
  } else {
    if (mobileId !== '') {
      window._klOnsite.push(['openForm', mobileId]);
    } else {
      window._klOnsite.push(['openForm', desktopId]);
    }
  }
}

let isClickEventAdded = false;

function handleResize() {
  if (!isClickEventAdded) {
    stickyNewsletterButton.addEventListener('click', openStickyNewsletterForm);
    isClickEventAdded = true;
  }
}

handleResize();
window.addEventListener('resize', handleResize);